/**
 * Returns the Optimizely Web visitor ID (`oeu<timestamp>r<random>`) — the value
 * Optimizely attributes experiment decisions to. Relayed to Shopify checkout as
 * a cart attribute so Order Completed, which fires from the checkout pixel, can
 * be matched back to the visitor's bucketing via Optimizely's Event API.
 *
 * Prefers the documented JS API. Before the snippet initializes, `window.optimizely`
 * is still the async push queue and has no `get`, so fall back to the cookie —
 * Optimizely warns its cookie format may change, hence API first.
 */
export const getOptimizelyVisitorId = (): string | null => {
  if (typeof window === 'undefined') return null;

  // Never let a snippet-internal throw escape into the cart-create path.
  try {
    if (typeof window.optimizely?.get === 'function') {
      const visitorId = window.optimizely.get('visitor_id')?.randomId;
      if (visitorId) return visitorId;
    }
  } catch (error) {
    console.error('Failed to read Optimizely visitor ID:', error);
  }

  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)optimizelyEndUserId=([^;]*)/);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]) || null;
  } catch {
    return null;
  }
};
